import React, { useEffect, useState } from 'react';
import './AddProject.scss';
import firebase from '../../../FirebaseConfig/firebase';
import { uploadFile } from '../../../services/DashboardService';
import Select from 'react-select';
import { FaHornbill } from 'react-icons/fa';
import Spinner from '../../SpinnerComponent/Spinner';
import FB from 'firebase';
import { useHistory } from 'react-router-dom';

const AddProject = () => {

    const [files, setFiles] = useState([]);
    const [progress, setProgress] = useState(0);
    const [imageURLs, setImageURLs] = useState([]);
    const [title, setTitle] = useState('');
    const [description, setDescription] = useState('');
    const [caption, setCaption] = useState('');
    const [date, setDate] = useState();
    const [loaction, setLoaction] = useState('');
    const [year, setYear] = useState('2021/2022');
    const [checkUploading, setCheckUploading] = useState(false);
    const [thumbnailimage, setThumbnailimage] = useState(null);
    const [projectyear, setProjectyear] = useState('2021/2022');
    const [thumbnailimageURL, setThumbnailimageURL] = useState('');
    const [viewingYear, setViewingYear] = useState({ value: '2021/2022', label: '2021/2022' });
    const [addMark, setAddMark] = useState(false);
    const [thumbFileName, setThumbFileName] = useState('');
    const history = useHistory();

    const onFileChange = e => {
        for (let i = 0; i < e.target.files.length; i++) {
            const newFile = e.target.files[i];
            newFile['id'] = Math.random();
            // add an "id" property to each File object
            setFiles(prevState => [...prevState, newFile]);
        }
    };

    const submitproject = async (e) => {
        e.preventDefault();
        setCheckUploading(true);
        const storageRef = firebase.storage().ref();
        const temp = [];
        let fileNameArray = [];
        files.forEach((file) => {
            console.log('File:', file);
            let fileName = `${Date.now().toString()}${Math.random() * 1000}`;
            storageRef
                .child(`projectimages/${fileName}`)
                .put(file).then(async (snapshot) => {
                    const publicURL = await snapshot.ref.getDownloadURL();
                    temp.push(publicURL);
                    fileNameArray.push(fileName);
                    if (temp.length === files.length) {
                        console.log('function called');
                        await uploadThumbnail(e, temp, fileNameArray);
                    }
                });
        });

    };

    const addProject = (e, fileUrls, fileNameArray, thumbFileName, thumbnailimageURL) => {
        e.preventDefault();
        e.target.reset();
        const addedProject = firebase.firestore().collection('projects');
        const projectDetails = {
            title: title,
            description: description,
            caption: caption,
            date: date,
            thumbnailimageURL: thumbnailimageURL,
            loaction: loaction,
            projectyear: projectyear,
            imageURLs: fileUrls,
            comments: [],
            fileNameArray: fileNameArray,
            thumbFileName: thumbFileName,
            createdOn: FB.firestore.FieldValue.serverTimestamp()
        };
        console.log(projectDetails);
        addedProject.add(projectDetails).then(async () => {
            setCheckUploading(false);
            setAddMark(true);
            console.log('project added');
            //await timeout(2000);
            history.push('/projects');
        });

    };

    const handleThumbnailChange = (image) => {
        setThumbnailimage(image);
    };

    const uploadThumbnail = async (e, temp, fileNameArray) => {
        const storageReference = firebase.storage().ref();
        let fileName = `${Date.now().toString()}${Math.random() * 1000}`;
        let publicURL;
        await storageReference
            .child(`projectimages/${fileName}`)
            .put(thumbnailimage).then(async (snapshot) => {
                publicURL = await snapshot.ref.getDownloadURL();
            });
        addProject(e, temp, fileNameArray, fileName, publicURL);
    };

    useEffect(() => {

    }, [year]);

    const projectYear = [
        { value: '2022/2023', label: '2022/2023' },
        { value: '2021/2022', label: '2021/2022' },
        
    ];

    const selectedYear = (value) => {
        setProjectyear(value.value);
        setViewingYear(value);
        // console.log(value.value);

    };

    //const timeout = (number) => {
    //    return new Promise(res => setTimeout(res, delay));
    //};

    return (
        <div className="container-md  addproject-container">
            <div class="d-flex2 justify-content-center2">
                <div className="row">

                    <div class="m-4" >
                        <h4 class="display-4 addproject-title"><FaHornbill />&nbsp;&nbsp;<b>Add Project</b> </h4>
                    </div>
                    <hr />

                    {/* <img src="/assets/images/addproject_cover_vertical.jpg" class="img-fluid" width="100%" alt="" /> */}

                    <div className="col-md-8">
                        <br />
                        <form onSubmit={submitproject}>
                            <div class="form-group p-2">
                                <label >Project <b>Title</b></label>
                                <input type="text" class="form-control mt-1" id="exampleInputEmail1" name="title"
                                    onChange={(e) => { setTitle(e.target.value); }} placeholder="Enter Project Title" />

                                <br />

                                <label>Project <b>Description</b></label>
                                <textarea class="form-control mt-1" id="exampleFormControlTextarea1" onChange={(e) => {
                                    setDescription(e.target.value);
                                }} placeholder="Type Project Description here" rows="6"></textarea>

                                <br />

                                <label >Project <b>Caption by</b></label>
                                <input type="text" class="form-control mt-1" id="exampleInputEmail1" defaultValue="Leo "
                                    onChange={(e) => { setCaption(e.target.value); }} />

                                <br />

                                <label>Project <b>Date</b></label> &nbsp;&nbsp;&nbsp;

                                <input type="date"
                                    onChange={(e) => {
                                        setDate(e.target.value);
                                    }}
                                />

                                <br />
                                <br />

                                <label >Project <b>Thumbnail</b></label> &nbsp;&nbsp;&nbsp;
                                <input type="file" class="custom-file-input mt-1" id="customFile" onChange={(e) => handleThumbnailChange(e.target.files[0])} />

                                <br />
                                <br />

                                <label >Project <b>Location</b></label>
                                <input type="text" class="form-control mt-1" id="exampleInputEmail1" name="location"
                                    onChange={(e) => { setLoaction(e.target.value); }} placeholder="Enter Project Location" />

                                <br />

                                <label >Project <b>Year</b></label>
                                <Select options={projectYear}
                                    onChange={value => selectedYear(value)}
                                    value={viewingYear}
                                />

                                <br />

                                <label >Project <b>Photos</b></label> &nbsp;&nbsp;&nbsp;
                                <input type="file" class="custom-file-input mt-1" id="customFile" multiple onChange={onFileChange} />
                                {
                                    checkUploading && <div><Spinner /> <p>Uploading your project ...</p></div>
                                }
                                {
                                    addMark && <p>Project Added Successfully</p>
                                }
                                <br />
                                <button class="btn btn-primary mt-4" type="submit" >Submit Project</button>
                            </div>
                        </form>




                        {/* <div className="addproject-form-field">
                            <label>Project Date</label>
                            <input type="date"
                                onChange={(e) => {
                                    setDate(e.target.value);
                                }}
                            />
                        </div> */}

                        {/* <div className="addproject-form-field">
                            <label>Project Thumbnail Photo</label>
                            <input type="file" onChange={(e) => uploadThumbnailPhoto(e.target.files[0])} />
                        </div> */}


                        {/* <div className="addproject-form-field">
                            <label>Project Location</label>
                            <input type="text"
                                onChange={(e) => {
                                    setLoaction(e.target.value);
                                }}
                            />
                        </div> */}

                        {/* <div className="addproject-form-field">
                            <label>Project Year</label>
                            <div>
                                <select onChange={(e) => {
                                    setYear(e.target.value);
                                }}>
                                    <option>2020/2021</option>
                                    <option>2019/2020</option>
                                    <option>2018/2019</option>
                                </select>
                            </div>
                        </div> */}

                        {/* <div className="addproject-form-field">
                            <label>Project Photos</label>
                            <input type="file" multiple onChange={onFileChange} />
                        </div>
                        {
                            checkUploading && <p>...Uploading your project</p>
                        }
                        <button onClick={submitproject}>Upload</button> */}
                    </div>
                </div>
            </div>
            <br />
        </div>
    );
};

export default AddProject;